import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbStepperComponent, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import countryCodes from '@shared/data/countryCodes.json';
import { format } from 'date-fns';
import { LocalStorage } from 'src/app/core/localstorage';

import { UserService } from 'src/app/modules/user/user.service';
import { LocaleService } from 'src/app/shared/services/locale.service';
import { EmailValidator } from 'src/app/shared/utils/emailValidator';
import { AuthService } from '../../auth.service';
import { SetupService } from '@core/services/setup';
import {
    CdkDrag,
    CdkDragDrop,
    CdkDragEnter,
    CdkDragExit,
    CdkDragRelease,
    CdkDragSortEvent,
    CdkDropList,
    DropListRef,
    moveItemInArray,
    transferArrayItem,
} from '@angular/cdk/drag-drop';
import { PolicyService } from '@core/services/policy.service';
@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterComponent implements OnInit {
    countryCodes = countryCodes;
    public static matchValues(
        matchTo: string // name of the control to match to
    ): (AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            return !!control.parent &&
                !!control.parent.value &&
                control.value === control.parent.controls[matchTo].value
                ? null
                : { notMatch: true };
        };
    }

    // Declarações
    errors: any[]; // Coleção de erros com falhas vindo do servidor
    message: string; // Mensagem de falha/sucesso processada pela API
    statusCode: number; // Código da mensagem de falha/sucesso processada pela API
    loading: boolean = false;

    /**
     * Formulário de cadastro
     */
    formPreRegister: FormGroup;
    formRegister: FormGroup;
    formReceiveToken: FormGroup;

    /**
     * Alerta de erro e sucesso
     * TODO: Repensar;
     */
    alert = {
        show: false,
        message: '',
        type: 'success',
    };

    /**
     * Locale
     * lista de cidades, estados e paises
     */

    locale = {
        cities: [],
        states: [],
        countries: [],
    };

    player: string;
    typeSending: string;
    codeToken: string;

    /**
     * Flag para renderizações condicionais para cadastros do Brasil
     */
    isBrazil: boolean;

    /**
     * controls()
     */
    get controls() {
        return this.formRegister.controls;
    }
    /**
     * controls()
     */
    get prControls() {
        return this.formPreRegister.controls;
    }

    @ViewChild('stepper') stepper: NbStepperComponent;

    available_names: string[] = [];

    short_name: string[] = [];

    isCollapsed = true;

    hasDataInDropList = false;

    enteredInDropList: boolean = false;

    policies = [];

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private localeService: LocaleService,
        private router: Router,
        private title: Title,
        private setupService: SetupService,
        private translateService: TranslateService,
        private cd: ChangeDetectorRef,
        private toastrService: NbToastrService,
        private localStorage: LocalStorage,
        private userService: UserService,
        private policyService: PolicyService
    ) {
        // Setar o conjunto de mensagens de validação
        this.isBrazil = this.localStorage.isBrazil();
    }

    ngOnInit(): void {
        this.buildForm();
        this.getInitialLocale();
        // this.initRegisterFormAsEmpty();
        this.title.setTitle(`Cadastro - ${this.setupService.title}`);

        this.policyService.getPrivacyPolicy().subscribe((response) => {
            this.policies = response.registers;
        });

        this.listenEstrangeiroChange();
    }

    async getInitialLocale() {
        try {
            const res = await this.localeService.getCountries().toPromise();
            this.locale.countries = res.registers;
        } catch (error) {
            console.error(error);
        }
    }

    buildForm() {
        this.formPreRegister = this.formBuilder.group({
            email: new FormControl('', EmailValidator),
            estrangeiro: new FormControl(false),
            document: new FormControl('', [
                Validators.required,
                this.isBrazil ? Validators.minLength(11) : Validators.minLength(6),
            ]),
            zip_code: new FormControl('', [
                Validators.required,
                this.isBrazil ? Validators.minLength(8) : Validators.minLength(4),
            ]),
            celular_ddi: new FormControl('', [Validators.required, Validators.pattern(/^(\+?\d{1,4}|\d{1,4})$/)]),
            celular_ddd: new FormControl('', this.isBrazil ? Validators.required : null),
            celular_numero: new FormControl('', Validators.required),
        });
        this.formRegister = this.formBuilder.group({
            estrangeiro: new FormControl(false),
            email: new FormControl('', EmailValidator),
            document: new FormControl('', [Validators.required]),
            zip_code: new FormControl('', [Validators.required]),
            ddi: new FormControl('', [Validators.required]),
            ddd: new FormControl('', this.isBrazil ? Validators.required : null),
            cel_number: new FormControl('', [Validators.required]),
            first_name: new FormControl('', [Validators.required]),
            last_name: new FormControl('', [Validators.required]),
            dt_birthday: new FormControl(null, [Validators.required]),
            gender: new FormControl('', [Validators.required]),
            country: new FormControl(''),
            state: new FormControl('', [Validators.required]),
            city: new FormControl('', [Validators.required]),
            accept: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]),
            confirm_password: new FormControl('', [
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(16),
                RegisterComponent.matchValues('password'),
            ]),
            short_name_field: new FormControl('', [Validators.minLength(2), Validators.maxLength(3)]),
        });
    }

    onRegister() {
        if (this.formRegister.invalid) return console.error('Formulário não é válido', this.controls);
        if (!this.isShortNameValid(this.short_name)) {
            return console.log(this.short_name);
        }
        this.loading = true;
        console.log(this.formRegister.getRawValue());
        const formData = {
            ...this.formRegister.getRawValue(),
            dt_birthday: format(this.formRegister.getRawValue().dt_birthday, 'yyyy-MM-dd'),
            short_name_field: this.short_name.join(' '),
        };

        this.authService.registerUser(formData).subscribe(
            async (response) => {
                const success = response.status_code === 0;
                if (success) {
                    this.toastrService.success(
                        this.translateService.instant('ALERT.SUCCESS.DESCRIPTION'),
                        this.translateService.instant('ALERT.SUCCESS.TITLE')
                    );
                    this.player = response.registers.id_site;
                    this.cd.detectChanges();
                    setTimeout(() => {
                        this.stepper.next();
                        this.loading = false;
                    }, 200);
                } else {
                    this.toastrService.danger(
                        response.description || this.translateService.instant('ALERT.ERROR.DESCRIPTION'),
                        this.translateService.instant('ALERT.ERROR.TITLE')
                    );
                    this.loading = false;
                }
            },
            () => {
                this.toastrService.danger(
                    this.translateService.instant('ALERT.ERROR.DESCRIPTION'),
                    this.translateService.instant('ALERT.ERROR.TITLE')
                );
                this.loading = false;
            }
        );
    }

    preRegister() {
        if (this.formPreRegister.invalid) return;
        this.loading = true;
        const data = {
            ...this.formPreRegister.value,
            celular_ddi: Number(this.formPreRegister.value.celular_ddi),
            estrangeiro: Number(this.formPreRegister.value.estrangeiro),
        };
        this.authService.setRegister(data).subscribe(
            (response) => {
                this.statusCode = response.status_code;
                if (response.status_code === 0) {
                    this.patchValuesToRegister({
                        ...response.registers,
                        foreigner: this.formPreRegister.value.estrangeiro,
                    });
                    this.stepper.next();
                    this.alert.show = false;
                }
                if (response.status_code === 1) {
                    this.message = response.description;
                    this.errors = response.registers;
                    this.showGenericErrorAlert();

                    // Se não for array o erro é de documento inválido
                    if (!Array.isArray(response.registers)) {
                        const documentControl = this.formPreRegister.controls.document;
                        documentControl.setErrors({ invalidDocument: true });
                        const subs = documentControl.valueChanges.subscribe(
                            () => {
                                documentControl.setErrors(null);
                            },
                            () => {},
                            () => subs.unsubscribe()
                        );
                    }
                }

                this.loading = false;
                this.cd.detectChanges();
            },
            () => {
                this.showGenericErrorAlert();
                this.loading = false;
            }
        );
    }

    patchValuesToRegister(values) {
        const { celular_ddi, celular_ddd, celular_numero, dt_birthday, country, foreigner, ...rest } = values;

        let date_birthdayUTC = null;
        if (dt_birthday) {
            const date = new Date(dt_birthday);
            const userTimezoneOffset = date.getTimezoneOffset() * 60000;
            date_birthdayUTC = new Date(date.getTime() + userTimezoneOffset);
        }

        this.formRegister.patchValue({
            ddi: celular_ddi,
            ddd: celular_ddd,
            cel_number: celular_numero,
            country: country ? country.toString() : country,
            dt_birthday: date_birthdayUTC,
            estrangeiro: foreigner,
            ...rest,
        });

        Object.keys(this.controls).forEach((controlKey) => {
            const control = this.controls[controlKey];

            if (control.value) {
                control.disable();
            } else {
                control.enable();
            }
        });
        this.onLocaleChange('country', values.country);
        this.onLocaleChange('state', values.state);
    }

    onTokenSent({ code, type_sending }) {
        this.typeSending = type_sending;
        this.codeToken = code;
        this.stepper.next();
        this.cd.detectChanges();
    }

    onValidationSuccess() {
        this.loginUser();
    }

    /**
     * loga usuário
     */
    loginUser() {
        const { password } = this.formRegister.value;
        this.authService.login({ email: this.player, password }).subscribe((response) => {
            this.localStorage.saveToken(response.token);
            this.userService.saveUserToLocalStorage(response.registers.usuario);
            this.router.navigate(['/home']);
        });
    }

    onRecoverPassClick() {
        this.router.navigate(['/auth/request-password']);
    }

    listenEstrangeiroChange() {
        this.formPreRegister.get('estrangeiro').valueChanges.subscribe((value) => {
            if (value) {
                this.formPreRegister.get('document').setValidators([Validators.required, Validators.minLength(6)]);
            } else {
                this.formPreRegister
                    .get('document')
                    .setValidators([
                        Validators.required,
                        this.isBrazil ? Validators.minLength(11) : Validators.minLength(6),
                    ]);
            }
            this.formPreRegister.get('document').updateValueAndValidity();
        });
    }

    onDDIAutocompleteChange(event) {
        const search = event.target.value?.toLowerCase();
        this.countryCodes = countryCodes.filter((country) => {
            const name = country.name.toLowerCase();
            const code = country.dial_code;

            return name.includes(search) || code.includes(search);
        });
    }

    async onLocaleChange(type, localeId) {
        let res;
        switch (type) {
            case 'country':
                this.formRegister.patchValue({
                    state_id: null,
                    city_id: null,
                });
                this.locale.cities = [];
                this.locale.states = [];
                res = await this.localeService.getStates(localeId).toPromise();
                this.locale.states = res.registers;
                break;
            case 'state':
                this.formRegister.patchValue({
                    city_id: null,
                });
                this.locale.cities = [];
                res = await this.localeService.getCities(localeId).toPromise();
                this.locale.cities = res.registers;
                break;
            default:
                break;
        }
    }

    showGenericErrorAlert(message?: string) {
        this.alert.message = message || this.translateService.instant('ALERT.ERROR.DESCRIPTION');
        this.alert.type = 'danger';
        this.alert.show = true;
    }

    handleButtonClick() {
        this.isCollapsed = !this.isCollapsed;

        if (this.isCollapsed === true) {
            this.formRegister.get('short_name_field').reset();
        }

        this.handleSplitName();
    }

    handleSplitName() {
        this.available_names = [];
        this.short_name = [];
        const first_name = this.formRegister.get('first_name').value;
        const last_name = this.formRegister.get('last_name').value;

        this.splitNames(first_name, last_name);
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }

        this.enteredInDropList = false;

        if (event.container.id === 'drop-list') {
            this.short_name = event.container.data;
            this.isShortNameValid(this.short_name);
            this.hasNamesInDropList(this.short_name);
        } else if (event.previousContainer.id === 'drop-list') {
            this.short_name = event.previousContainer.data;
            this.isShortNameValid(this.short_name);
            this.hasNamesInDropList(this.short_name);
        }
    }

    maximumLimitAllowed(item: CdkDrag<string>, dropList: CdkDropList) {
        if (dropList.data.length <= 2) {
            return true;
        }
        return false;
    }

    splitNames(firstName: string, lastName: string) {
        let combinedName = `${firstName.trim()} ${lastName.trim()}`;
        let arrayNameParts = combinedName.split(' ');
        this.available_names = arrayNameParts;
    }

    isShortNameValid(shortName: Array<string>): boolean {
        if ((shortName.length >= 2 && shortName.length <= 3) || shortName.length === 0) {
            this.formRegister.get('short_name_field').reset();
            return true;
        }
        this.formRegister.get('short_name_field').setErrors({ customError: true });
        return false;
    }

    hasNamesInDropList(shortName: Array<string>): void {
        if (shortName.length === 0) {
            this.hasDataInDropList = false;
            return;
        }
        this.hasDataInDropList = true;
    }

    dropListEntered() {
        this.enteredInDropList = true;
    }

    listenToForeignCheckChange() {
        this.formPreRegister.get('estrangeiro').valueChanges.subscribe((checked) => {
            if (checked) {
                this.formPreRegister.get('document').setValidators([Validators.required, Validators.minLength(6)]);
            }
        });
    }
}
